export default __webpack_public_path__ + "static/media/background.56bc83ea.jpg";